// Placement is stored as one comma-joined string ("APP", "WEB" or "APP,WEB")
// so a content page can be published to more than one surface at a time.

export const PLACEMENT_VALUES = ['APP', 'WEB'];

export const PLACEMENT_OPTIONS = [
  { value: 'APP', label: 'App' },
  { value: 'WEB', label: 'Web' },
];

// String or array in, always an array of known placements out.
export function toPlacementList(value) {
  const list = Array.isArray(value) ? value : String(value || '').split(',');
  return PLACEMENT_VALUES.filter(placement => list.includes(placement));
}

export function toPlacementValue(value) {
  return toPlacementList(value).join(',');
}

export function hasPlacement(value, placement) {
  return toPlacementList(value).includes(placement);
}
